import { Breadcrumb, Col, ConfigProvider, DatePicker, PaginationProps, Row, Select, Space, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import * as echarts from "echarts";
import ReactECharts from "echarts-for-react";
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import Layout from '../../../Layout';
import { CampaignStats, getChartCustomerReportRank, getChartMemberFluctuation, getChartReportRankDemographics, getListCustomerMemberRankSummary, getReportRankCustomerDistributionByAge, getReportRankCustomerDistributionByJob, getReportRankCustomerDistributionByRegion, IChartCustomerReportRank, IChartMemberFluctuation, IChartReportRankDemographics, ICustomerMemberRankSummary, IReportCampaign, IReportCampaignVehicleDistributionByAgeV2 } from '../../../api/reportCustomer/reportCustomerApi';
import { getListRank, getSLUnitByPermission, IRank, ISelectOption } from '../../../api/selectOptions/selectOptionsApi';
import { convertNationwideValueToTree_V2 } from '../../../api/unit/unitApi';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import { formatNumber } from '../../../services/mixin';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { fommatSelectOptionV2, formatDateV2, formatPrice, getUserPermissions } from '../../../until';
import StatisticCard from './StatisticCard';
import { ChartCard } from './components/ChartCard';
import { CustomerTypePie } from './components/CustomerTypePie';
import { CustomerTypePieBusiness } from './components/CustomerTypePieBusiness';
import { GenderDonut } from './components/GenderDonut';
import { HorizontalBarChart } from './components/HorizontalBarChart';
import MembershipTierMonthlyTable from './components/MembershipTierMonthlyTable';
import RankPieChart from './components/RankPieChart';
import ReportFluctuationYearly from './components/ReportFluctuationYearly';
import ReportTableTotalMembers from './components/ReportTableTotalMembers';
import './styles.scss';

const { RangePicker } = DatePicker;

export enum TYPEFILTERTOP {
    ADDRESS = 0,
    JOB = 1,
}


interface CustomerGrowthData {
    year: number;
    totalCustomers: number;
    growthCount: number;
    growthRate: number;
}

interface CustomerGrowthChartData {
    years: string[];
    totalCustomers: number[];
    growthRates: number[];
}

export interface ChartData {
    name: string;
    value: number;
    color: string;
    id?: number;
}

const DEFAULT_COLORS = [
    "#3D99F5", // Member
    "#39C2C9", // Silver
    "#45C35B", // Gold
    "#FFC928", // Plantium
    "#F15672", // Diamond
    "#8B56DD", // Diamond 1
    "#4E56D9", // Diamond 2
    "#344A91", // Không xác định
];

const randomColor = (): string => {
    const letters = "0123456789ABCDEF";

    let color = "#";

    for (let i = 0; i < 6; i++) {
        color += letters[
            Math.floor(Math.random() * 16)
        ];
    }

    return color;
};

const convertRankDataToChartData = (
    data: IChartCustomerReportRank[] | undefined | null
): ChartData[] => {

    if (!data || data.length === 0) {
        return [];
    }

    return data.map((item, index) => ({
        name: item.rankName,
        value: item.count,
        color:
            index < DEFAULT_COLORS.length
                ? DEFAULT_COLORS[index]
                : randomColor(),
        id: item.rankId,
    }));
};




const convertCustomerGrowthData = (
    data: IChartMemberFluctuation[] | undefined | null
): CustomerGrowthChartData => {

    if (!data?.length) {
        return {
            years: [],
            totalCustomers: [],
            growthRates: [],
        };
    }

    return {
        years: data.map(item => String(item.year)),

        totalCustomers: data.map(
            item => item.totalCustomers ?? 0
        ),

        growthRates: data.map(
            item => item.growthRate ?? 0
        ),
    };
};


const buildTopWithOther = (
    data: { name: string; value: number }[],
    top: number
) => {
    const sorted = [...data].sort((a, b) => b.value - a.value);
    const main = sorted.slice(0, top - 1);
    const otherSum = sorted.slice(top - 1).reduce((s, i) => s + i.value, 0);

    return otherSum > 0 ? [...main, { name: "Khác", value: otherSum }] : main;
};

const convertAgeRangeToValue = (value?: string | null): number | undefined => {
    if (!value) return undefined;

    const normalized = value
        .trim()
        .replace(/\s+/g, "");

    const ageRangeMap: Record<string, number> = {
        "Khôngxácđịnh": 0,
        "<20": 1,
        "20-25": 2,
        "26-29": 3,
        "30-39": 4,
        "40-49": 5,
        "50-59": 6,
        "60+": 7
    };

    return ageRangeMap[normalized];
};

interface CustomerFilterSearch {
    campaign?: string
}

export interface TypeTotalReport {
    zns?: CampaignStats
    sms?: CampaignStats
    email?: CampaignStats
}

export interface IDataDefaulFilter {
    unitIds?: number[],
    rankIds?: number[],
    fromMonth?: string,
    toMonth?: string,
}

const MembershipTier: React.FC = () => {
    const pushToast = useToast();
    const pushLoading = useLoading()
    const navigate = useNavigate()

    const location = useLocation();
    const { unitTemp } = useSelector(selectorInfoUser)

    const permissionSlice = useSelector(selectorPermission)
    const { add, edit, delete: isdelete, upload, download } = getUserPermissions(permissionSlice, location.pathname)
    const [dataReportRankDemographics, setDataReportRankDemographics] = useState<IChartReportRankDemographics>()
    const [dataReportCampaignVehicleDistributionByAge, setDataReportCampaignVehicleDistributionByAge] = useState<IReportCampaignVehicleDistributionByAgeV2>()
    const [dataReportCampaignCustomerAddress, setDataReportCampaignCustomerAddress] = useState<any[]>()
    const [dataReportCampaignCustomerJob, setDataReportCampaignCustomerJob] = useState<any[]>()

    // data báo cáo hạng thành viên


    const [dataCustomerMemberRankSummary, setDataCustomerMemberRankSummary] = useState<ICustomerMemberRankSummary>()


    const [dataChartCustomerReportRank, setDataChartCustomerReportRank] = useState<ChartData[]>()
    const [dataChartMemberFluctuation, setDataChartMemberFluctuation] = useState<CustomerGrowthChartData>()
    const [dataRank, setDataRank] = useState<IRank[]>([])
    const [sLUnitByPermission, setSLUnitByPermission] = useState<any>()






    const [dataFilter, setDataFilter] = useState<IDataDefaulFilter>()
    const [total, setTotal] = useState<number>()



    const [valueTop, setValueTop] = useState<Record<TYPEFILTERTOP, number>>({
        [TYPEFILTERTOP.ADDRESS]: 10,
        [TYPEFILTERTOP.JOB]: 10,
    });


    const dataCampaignVehicleDistributionByAge = useMemo(() => {
        if (!dataReportCampaignVehicleDistributionByAge) return [];
        const sum = (key: keyof IReportCampaignVehicleDistributionByAgeV2) => dataReportCampaignVehicleDistributionByAge[key] || 0;
        return [
            { name: 'Không xác định', value: dataReportCampaignVehicleDistributionByAge.undetermined },
            { name: '< 20', value: dataReportCampaignVehicleDistributionByAge.ageUnder20 },
            { name: '20 - 25', value: dataReportCampaignVehicleDistributionByAge.ageBetween2025 },
            { name: '26 - 29', value: dataReportCampaignVehicleDistributionByAge.ageBetween2629 },
            { name: '30 - 39', value: dataReportCampaignVehicleDistributionByAge.ageBetween3039 },
            { name: '40 - 49', value: dataReportCampaignVehicleDistributionByAge.ageBetween4049 },
            { name: '50 - 59', value: dataReportCampaignVehicleDistributionByAge.ageBetween5059 },
            { name: '60+', value: dataReportCampaignVehicleDistributionByAge.ageOver60 },
        ];
    }, [dataReportCampaignVehicleDistributionByAge]);




    const dataFormatCustomerAddress = useMemo(() => buildTopWithOther(dataReportCampaignCustomerAddress ?? [], valueTop[TYPEFILTERTOP.ADDRESS])
        , [dataReportCampaignCustomerAddress, valueTop[TYPEFILTERTOP.ADDRESS]])


    const dataFormatCustomerJob = useMemo(() => buildTopWithOther(dataReportCampaignCustomerJob ?? [], valueTop[TYPEFILTERTOP.JOB])
        , [dataReportCampaignCustomerJob, valueTop[TYPEFILTERTOP.JOB]])

    const gSLRank = async () => {
        const result = await getListRank();
        if (result?.status) {
            setDataRank(result.data)
        } else {
            pushToast(result?.message, "error", 2000)

        }
    }

    const gSLUnitByPermission = async () => {
        const result = await getSLUnitByPermission(unitTemp);
        if (result?.status) {
            setSLUnitByPermission(convertNationwideValueToTree_V2(result.data))
        } else {
        }
    }


    const gListCustomerMemberRankSummary = useDebounce(async () => {
        pushLoading(true)
        const result = await getListCustomerMemberRankSummary(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.rankIds,
            dataFilter?.fromMonth,
            dataFilter?.toMonth,
        )
        if (result.status) {
            setDataCustomerMemberRankSummary(result.data)
        }
        pushLoading(false)
    }, 500)

    const gChartCustomerReportRank = useDebounce(async () => {
        pushLoading(true)
        const result = await getChartCustomerReportRank(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.rankIds,
            dataFilter?.fromMonth,
            dataFilter?.toMonth,
        )
        if (result.status) {
            setDataChartCustomerReportRank(convertRankDataToChartData(result.data))
        }
        pushLoading(false)
    }, 500)


    const gChartMemberFluctuation = useDebounce(async (limit: number = 5) => {
        pushLoading(true)
        const result = await getChartMemberFluctuation(
            limit,
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.rankIds,
            dataFilter?.fromMonth,
            dataFilter?.toMonth,
        )
        if (result.status) {
            setDataChartMemberFluctuation(convertCustomerGrowthData(result.data))
        }
        pushLoading(false)
    }, 500)

    const gChartReportRankDemographics = useDebounce(async () => {
        pushLoading(true)
        const result = await getChartReportRankDemographics(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.rankIds,
            dataFilter?.fromMonth,
            dataFilter?.toMonth,

        )
        if (result.status) {
            setDataReportRankDemographics(result.data)
            // setTotal(result.total)
        }
        pushLoading(false)
    }, 500)

    // const gListReportCampaign = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    //     pushLoading(true)
    //     const result = await getListReportCampaign(
    //         pageSize, pageCurent, unitTemp,
    //         dataFilter?.status, dataFilter?.dateCreate,
    //         dataFilter?.dateSend, dataFilter?.campaign, dataFilter?.brandName

    //     )
    //     if (result.status) {
    //         setDataReportCampaign(result.data)
    //         setPagination({ current: pageCurent, total: result.total, pageSize })
    //         setTotalReport({
    //             zns: result?.zns,
    //             sms: result?.sms,
    //             email: result?.email
    //         })
    //         setTotal(result.total)
    //     }
    //     pushLoading(false)
    // }, 500)



    const gReportRankCustomerDistributionByAge = useDebounce(async () => {
        pushLoading(true)
        const result = await getReportRankCustomerDistributionByAge(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.rankIds,
            dataFilter?.fromMonth,
            dataFilter?.toMonth,

        )
        if (result.status) {
            setDataReportCampaignVehicleDistributionByAge(result.data)
            // setTotal(result.total)
        }
        pushLoading(false)
    }, 500)

    const gReportRankCustomerDistributionByRegion = useDebounce(async () => {
        pushLoading(true)
        const result = await getReportRankCustomerDistributionByRegion(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.rankIds,
            dataFilter?.fromMonth,
            dataFilter?.toMonth,

        )
        if (result.status) {
            const raw = result.data.map(item => ({
                name: item.provinceName,
                value: item.total,
                id: item.provinceId
            }));
            setDataReportCampaignCustomerAddress(raw)
            // setTotal(result.total)
        }
        pushLoading(false)
    }, 500)



    const gReportRankCustomerDistributionByJob = useDebounce(async () => {
        pushLoading(true)
        const result = await getReportRankCustomerDistributionByJob(
            unitTemp,
            dataFilter?.unitIds,
            dataFilter?.rankIds,
            dataFilter?.fromMonth,
            dataFilter?.toMonth,
        )
        if (result.status) {
            const raw = result.data.map(item => ({
                name: item.jobName,
                id: item.jobId,
                value: item.total,
            }));
            setDataReportCampaignCustomerJob(raw)
            // setTotal(result.total)
        }
        pushLoading(false)
    }, 500)



    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        // gListReportCampaign(pageNumber, pageSize)
    }


    useEffect(() => {
        gListCustomerMemberRankSummary()
        gChartCustomerReportRank()
        gChartMemberFluctuation()
        gChartReportRankDemographics()
        gReportRankCustomerDistributionByAge()
        gReportRankCustomerDistributionByRegion()
        gReportRankCustomerDistributionByJob()
    }, [dataFilter, unitTemp])

    useEffect(() => {
        // gSLBrandName()
        gSLUnitByPermission()

    }, [unitTemp])

    useEffect(() => {
        // gSLBrandName()
        gSLRank()

    }, [])




    return (
        <div className='card-issuance-list'>
            <Layout  className='custom-sidebar-chart'>

                <Breadcrumb
                    items={[
                        {
                            title: 'THACO AUTO CRM',
                        },
                        {
                            title: <a href="/">Báo cáo phân tích</a>,
                        },
                        {
                            title: 'Tổng quan thành viên theo phân hạng',
                        },
                    ]}
                />

                <div className='title-page'>
                    Tổng quan thành viên theo phân hạng
                </div>


                <div className="campaign-filter">

                    <Space
                        wrap
                        size={16}
                        className="campaign-filter__toolbar"
                        align='start'
                    >
                        <TreeSelect
                            className='custom-page-css border rounded overflow-hidden w-300px custom-scroll-multi-select'
                            multiple
                            showSearch
                            placeholder="Đơn vị"
                            allowClear
                            value={dataFilter?.unitIds}
                            treeDefaultExpandAll={false}
                            treeData={sLUnitByPermission}
                            filterTreeNode={(input: string, option: any) =>
                                typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(e) => setDataFilter({ ...dataFilter, unitIds: e !== undefined ? e : undefined })}
                        />

                        {/* <Select
                            className="custom-page-css border rounded overflow-hidden w-200px custom-scroll-multi-select"
                            mode="multiple"
                            showSearch={false}
                            placeholder="Hạng thành viên"
                            options={sLBrandName}
                            // onChange={(e) => setDataFilter({ ...dataFilter, brandName: e !== undefined ? e : undefined })}
                            // onClear={() => setDataFilter({ ...dataFilter, brandName: undefined })}
                            suffixIcon={<DownOutlined />}
                        /> */}
                        <Select
                            className='custom-page-css border rounded overflow-hidden  w-200px  '
                            placeholder="Hạng thành viên"
                            allowClear
                            showSearch={false}
                            mode="multiple"
                            onClear={() => setDataFilter({ ...dataFilter, rankIds: undefined })}
                            onChange={(e) => setDataFilter({ ...dataFilter, rankIds: e !== undefined ? e : undefined })}
                            value={dataFilter?.rankIds}
                            options={fommatSelectOptionV2(dataRank)}
                        />

                        <ConfigProvider locale={viVN}>
                            <RangePicker
                                className="custom-input-date"
                                picker="month"
                                format="DD/MM/YYYY"
                                onChange={(dates) => {
                                    setDataFilter({
                                        ...dataFilter,
                                        fromMonth: dates?.[0]
                                            ? formatDateV2(dates[0].toDate())
                                            : undefined,
                                        toMonth: dates?.[1]
                                            ? formatDateV2(dates[1].toDate())
                                            : undefined,
                                    });
                                }}
                            />
                        </ConfigProvider>
                        {/* <ConfigProvider locale={viVN}>
                            <DatePicker
                                className="custom-input-date"
                                placeholder="Ngày gửi chiến dịch"
                                format="DD/MM/YYYY"
                                allowClear
                                onChange={(e) => setDataFilter({ ...dataFilter, dateSend: e ? formatDateV2(e.toDate()) : undefined })}
                            />
                        </ConfigProvider> */}

                        {/* <Button
                            icon={<DownloadOutlined />}
                            loading={isExporting}
                            onClick={handleExportExcel}
                        >
                            Xuất báo cáo
                        </Button> */}

                    </Space>

                </div>


                <div className='custom-page-css w-full flex  gap-2 pt-4'>

                    <div className="custom-page-css flex flex-1">
                        <StatisticCard
                            colors={['#1890FF', '#005DB2']}
                            title='Tổng số khách hàng thành viên'
                            value={formatNumber(dataCustomerMemberRankSummary?.totalMembers ?? 0)}

                        />
                    </div>

                    <div className="custom-page-css flex flex-1">
                        <StatisticCard
                            colors={['#F59C23', '#F55E09']}
                            title='Thành viên mới trong tháng'
                            value={formatNumber(dataCustomerMemberRankSummary?.newMembersInMonth ?? 0)}
                            grow={dataCustomerMemberRankSummary?.growthRate ?? undefined}

                        />
                    </div>

                    <div className="custom-page-css flex flex-1">
                        <StatisticCard
                            colors={['#7B61FF', '#4F00B2']}
                            title='Độ tuổi trung bình'
                            value={formatNumber(dataCustomerMemberRankSummary?.avgAge ?? 0)}

                        />
                    </div>
                </div>
                <div className="custom-page-css flex items-stretch gap-4 pt-4">
                    <div
                        className="custom-page-css flex flex-1 "
                    >
                        <RankPieChart
                            title="Biểu đồ tỉ lệ thành viên theo hạng"
                            data={dataChartCustomerReportRank ?? []}
                        />
                    </div>
                    <div
                        className="custom-page-css flex flex-col flex-1  border rounded-2 "
                    >
                        <Row
                            justify="space-between"
                            style={{
                                padding: 20
                            }}
                            align="stretch"
                        >
                            <Col>
                                <h3 className="custom-page-css text-base text-344054 font-medium "
                                    style={{
                                        height: 52
                                    }}

                                >Biểu đồ số lượng khách hàng thành viên tăng trưởng theo năm</h3>
                            </Col>

                            <Col>
                                <Select
                                    className='custom-page-css border rounded overflow-hidden'
                                    defaultValue={5}
                                    style={{ width: 120 }}
                                    options={[
                                        { value: 5, label: "Top 5" },
                                        { value: 10, label: "Top 10" },
                                        { value: 15, label: "Top 15" },
                                    ]}
                                    onChange={(e) => gChartMemberFluctuation(e)}
                                />
                            </Col>
                        </Row>

                        <ReactECharts
                            onEvents={{ click: (params: any) => console.log('Bar clicked:', params) }}
                            option={{

                                tooltip: {
                                    trigger: "axis",
                                    axisPointer: {
                                        type: "shadow"
                                    }
                                },
                                legend: {
                                    bottom: 0,
                                    icon: "circle",
                                    itemWidth: 10,
                                    itemHeight: 10,
                                    textStyle: {
                                        fontSize: 14,
                                        color: "#344054",
                                    }
                                },

                                grid: {
                                    left: 60,
                                    right: 20,
                                    top: 40,
                                    bottom: 70,
                                },

                                xAxis: {
                                    type: "category",
                                    data: dataChartMemberFluctuation?.years ?? [],
                                    axisTick: {
                                        show: false
                                    },
                                    axisLine: {
                                        lineStyle: {
                                            color: "#D0D5DD"
                                        }
                                    }
                                },

                                yAxis: {
                                    type: "value",
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                            type: "dashed",
                                            color: "#EAECF0",
                                        }
                                    },

                                    axisLine: {
                                        show: false
                                    },
                                    axisTick: {
                                        show: false
                                    }
                                },

                                series: [
                                    {
                                        name: "Số lượng khách hàng thành viên",
                                        type: "bar",
                                        data: dataChartMemberFluctuation?.totalCustomers ?? [],
                                        barWidth: 70,
                                        itemStyle: {
                                            borderRadius: [
                                                0,
                                                0,
                                                0,
                                                0
                                            ],
                                            color: new echarts.graphic.LinearGradient(
                                                0,
                                                0,
                                                0,
                                                1,
                                                [
                                                    {
                                                        offset: 0,
                                                        color: "#4AA3FF",
                                                    },
                                                    {
                                                        offset: 1,
                                                        color: "#B7DCFF",
                                                    },
                                                ]
                                            )
                                        }
                                    },
                                    {
                                        name: "% tăng trưởng",
                                        type: "line",
                                        data: dataChartMemberFluctuation?.growthRates ?? [],
                                        smooth: true,
                                        symbol: "none",
                                        lineStyle: {
                                            width: 3,
                                            color: "#FF5B6B",
                                        }
                                    }

                                ]

                            }}

                            style={{

                                width: "100%",

                                height: "450px"

                            }}
                        />
                    </div>
                </div>


                {/* ở đây */}
                <ReportFluctuationYearly
                    dataFilter={dataFilter}
                />




                <MembershipTierMonthlyTable dataFilter={dataFilter} dataRank={dataRank} />

                <span className='text-base font-medium pt-4'>Báo cáo tổng thành viên theo công ty tỉnh thành</span>
                <ReportTableTotalMembers dataFilter={dataFilter} dataRank={dataRank} setTotal={setTotal} />
                {/* 
                <span className='text-base font-medium pt-4'>Báo cáo tình trạng gửi chiến dịch CSKH/ MKT</span>
                <CampaignTable
                    dataReportCampaign={dataReportCampaign}
                    totalReport={totalReport}
                    pagination={pagination}
                    onPaginationChange={onPaginationChange}
                /> */}
                <div className='custom-page-css flex flex-col gap-1 pt-4'>
                    <span className='custom-page-css text-base font-medium'> Báo cáo nhân khẩu học khách hàng</span>
                    <span className='custom-page-css text-base font-regular text-italic text-344054'>
                        Đang hiển thị dữ liệu tổng hợp từ{" "}
                        <span
                            style={{
                                color: "#1677FF",
                                fontWeight: 500,
                                fontStyle: "normal",
                                padding: '0 4px'
                            }}
                        >
                            {formatNumber(total ?? 0)} đơn vị
                        </span>{" "}
                        phía trên
                    </span>

                </div>

                <div className="custom-page-css flex items-stretch gap-4 pt-4">
                    <div
                        className="custom-page-css flex flex-1 "
                    >
                        <ChartCard title="Biểu đồ tỉ lệ phân loại khách hàng" >
                            <CustomerTypePieBusiness
                                data={dataReportRankDemographics?.businessCheck}
                                dataFilter={dataFilter}
                            />
                        </ChartCard>
                    </div>
                    <div
                        className="custom-page-css flex flex-1 "
                    >
                        <ChartCard title="Biểu đồ tỉ lệ giới tính" >
                            <GenderDonut
                                data={dataReportRankDemographics?.gender}
                                dataFilter={dataFilter}

                            />
                        </ChartCard>
                    </div>

                    <div
                        className="custom-page-css flex flex-1 ">
                        <ChartCard title="Biểu đồ  tỉ lệ tình trạng hôn nhân" >
                            <CustomerTypePie
                                data={dataReportRankDemographics?.statusMarital}
                                dataFilter={dataFilter}

                            />
                        </ChartCard>
                    </div>
                </div>

                <div className="custom-page-css flex items-stretch gap-4 pt-4">
                    <div
                        className="custom-page-css flex flex-col flex-1 border rounded-2 gap-2 p-6"
                        style={{ border: '1px solid #eaebec' }}
                    >
                        <div className="custom-page-css flex justify-between items-center mb-2">
                            <h3 className="custom-page-css text-344054 text-base font-medium">Biểu đồ phân bố khách hàng theo độ tuổi</h3>
                        </div>
                        <div style={{ width: '100%', height: 420 }}>
                            <ResponsiveContainer>
                                <BarChart
                                    data={dataCampaignVehicleDistributionByAge}
                                    margin={{ top: 8, right: 20, left: 20, bottom: 8 }}

                                    onClick={(params) =>
                                        navigate(
                                            `/analysis-report/member-card-list`,
                                            {
                                                state: {
                                                    type: 3,
                                                    listUnit: dataFilter?.unitIds,
                                                    listRank: dataFilter?.rankIds,
                                                    fromMonth: dataFilter?.fromMonth,
                                                    toMonth: dataFilter?.toMonth,
                                                    ageGroup: convertAgeRangeToValue(params.activeLabel),
                                                    title: `Khách hàng ở độ tuổi ${params.activeLabel}`
                                                }
                                            }
                                        )
                                        // console.log('dataCampaignVehicleDistributionByAge', convertAgeRangeToValue(params.activeLabel))

                                    }
                                >
                                    <defs>
                                        <linearGradient id="ownershipGradient" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#1890FF" stopOpacity={0.9} />
                                            <stop offset="95%" stopColor="#9DD0FF" stopOpacity={0.7} />
                                        </linearGradient>
                                    </defs>
                                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                    <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                                    <YAxis tickFormatter={(value: number) => formatPrice(value)} />
                                    {dataCampaignVehicleDistributionByAge.length > 0 && (
                                        <Tooltip
                                            labelFormatter={(label) => ` ${label}`}
                                            formatter={(value: number) => [`${formatNumber(value ?? 0)}`, 'Giá trị']}
                                        />
                                    )}
                                    <Bar dataKey="value" fill="url(#ownershipGradient)" radius={[4, 4, 0, 0]} barSize={60} />

                                </BarChart>
                            </ResponsiveContainer>

                        </div>
                    </div>
                </div>


                <div className="custom-page-css flex items-stretch gap-4 pt-4">
                    <div
                        className="custom-page-css flex flex-1">
                        <HorizontalBarChart
                            type={TYPEFILTERTOP.ADDRESS}
                            title="Top khách hàng theo khu vực"
                            data={dataFormatCustomerAddress}
                            valueTop={valueTop}
                            setValueTop={setValueTop}
                            color="#8979FF"
                            dataFilter={dataFilter}

                        />
                    </div>

                    <div
                        className="custom-page-css flex flex-1">
                        <HorizontalBarChart
                            type={TYPEFILTERTOP.JOB}
                            title="Top khách hàng theo nghề nghiệp"
                            data={dataFormatCustomerJob}
                            valueTop={valueTop}
                            setValueTop={setValueTop}
                            color="#1890FF"
                            dataFilter={dataFilter}

                        />
                    </div>
                </div>

            </Layout>
        </div>
    );
}

export default MembershipTier;
